module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido18.e37022db.svg";